import React from "react";
import { ReactSelect } from "../FilterCard";
import domain from "../../Domain";
import {
  parseDate,
  toLocalDateTime,
  getPageOptions,
  getBrandingImage,
  hideModal,
  showModalNoOutsideClick,
  getNameFromID,
  removeNull,
  getSelectLabels,
  toLocalDate,
} from "../../util/FormatUtil";
import Overlay from "../Overlay";
import ReactToPrint from "react-to-print";
import { Sample } from "../../types/Sample";
import SimpleTable from "../tables/SimpleTable";
import { SamplesModal } from "../modals/SamplesModal";
import { HintModal } from "../modals/HintModal";
import { TestReport, TestReportAddtlInfo } from "../../types/TestReport";
import TestResult from "../TestResult";
import { ImageType } from "../../types/Branding";
import Select from "react-select";
import { BsCheck, BsFilter, BsFillRecord2Fill } from "react-icons/bs";
import PhoneInput from "react-phone-number-input";
import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";
import TestType from "../../types/TestType";
// import moment from "moment";
import moment from "moment-timezone";

import { sweetalert } from "../../App";
import NetworkUtil from "../../network/NetworkUtil";
import TestsAPI from "../../network/TestsAPI";
import SystemAPI from "../../network/SystemAPI";
import SamplesAPI from "../../network/SamplesAPI";
import BatchesAPI from "../../network/BatchesAPI";
import { Column } from "../tables/TableBase";
import { Sorter, TableOrder } from "../../sorting/Sorter";
import AdminAPI from "../../network/AdminAPI";
import { AdminPages } from "./AdminNav";
import CustomFieldsAPI from "../../network/CustomFieldsAPI";
import { BinAPI } from "../../network/BinAPI";
import { FaInfoCircle } from "react-icons/fa";
import PaginationTool from "../PaginationTool";
import ServicesAPI from "../../network/ServicesAPI";
import ViewTestInfoModal from "../modals/ViewTestInfoModal";
import SampleFilterTabs from "./SampleFilterTabs";
import { PodSchedForSelect } from "../../types/PodSched";
import { standardPatientFields } from "../../types/CustomFieldType";
import { ReportSelectModal } from "../modals/ReportSelectModal";
import { ReqFormSelectModal } from "../modals/ReqFormSelectModal";
import ProviderAPI from "../../network/ProviderAPI";
import { fetchFieldPermissions } from "../../util/FieldPermissionsFetcher";
import { ReportDownloadHistoryModal } from "../modals/ReportDownloadHistoryModal";
import { ReportDownloadSummary, ReportType, REPORT_TYPE_LABELS } from "../../types/ReportDownload";
import { openPDFInNewTab } from "../../util/PDFUtil";
import { escapeHTML } from "../../util/FormatUtil";
//send filteredObj to backend to get data to display in table

interface ResultsReportState extends Sample {
  states: any;
  statuses: any;
  countries: any;
  counties: any;
  gender: any;
  ethnicity: any;
  race: any;
  specimen_source: any;
  tests: any;
  testDetails: TestType[];
  pods: { label: string; value: number }[];
  selectedSample?: Sample;
  samples?: Sample[];
  totalSamples?: number;
  podsForModal: { label: string, value: number }[];
  showLoading: boolean;
  facilities?;
  facilitiesForSampleModal?
  facilityGroups?;
  resultTypes?;
  selectedPod?;
  hintHeader?;
  hintContent?;
  getResultsButtonEnabled?: boolean;
  isGlobal?: boolean;
  isAdmin?: boolean;
  direction: TableOrder;
  page_options: ReactSelect[];
  selected_page?;
  tableData?;
  pdfData?;
  PodID?;
  sampleArrowDown?;
  patientArrowDown?;
  validSpecimenSources?;
  validResultTypes?;
  batchesForFilter?;
  batchesForModal?;
  BatchNum;
  binIDsForFilter?;
  binIDsForModal?;
  BinID;
  isGlobalAdminorLab?;
  searched?;
  customFields?
  customQuestions?;
  services?;
  filteredObj
  customPatientFields?;
  showLoadingResultReport;
  reportsGenerating;
  facilityLabels
  facilityIDFromAdminHomeButtons?
  reqNumFromURL?: string
  processing?
  completed?
  submittingProviderList?
  selectAllChecked?: boolean
  reqNumsToDownload?: { reqNum: string, hasResults: boolean }[]
  // keyed by ReqNum -> ReportType -> summary
  downloadSummary?: { [reqNum: string]: { [reportType: string]: ReportDownloadSummary } }
  downloadHistoryReqNum?: string
  downloadHistoryRefreshKey?: number
  userRoles?: string;
  fieldPermissions?: Record<string, number[]>;
}

export default class SamplesReport extends React.Component<
  any,
  ResultsReportState
> {
  private componentRef: any;
  private componentRefBR: any;
  private sampleFilterTabsRef: any;
  private paymentFormRef: any;

  constructor(props) {
    super(props);
    this.state = {
      selected_page: { label: 1, value: 1 },
      // Read here, not in componentDidMount - SampleFilterTabs takes it as its initial filter on first render
      reqNumFromURL: new URLSearchParams(window.location.search).get('reqNum') || undefined,
      sampleArrowDown: false,
      patientArrowDown: false,
      ApptCanceled: [{ label: "No", value: "*null" }],
      RerunFlag: [{ label: "No", value: "*null" }],
      states: [],
      statuses: [],
      countries: [],
      gender: [],
      ethnicity: [],
      race: [],
      specimen_source: [],
      tests: [],
      binIDs: [],
      batches: [],
      showLoading: false,
      pods: [],
      facilities: [],
      facilityGroups: [],
      samples: [],
      totalSamples: 0,
      resultTypes: [],
      podsForModal: [],
      direction: "asc",
      sampleModalOpen: false,
      page_options: [{ value: "1", label: "1" }],
      filteredObj: {},
      processing: false,
      completed: false,
      hintHeader: "Samples Filter Hints",
      hintContent: [
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Click on table headers to sort.</span>,
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Place cursor over search labels for field description.</span>,
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Filter icon ( <BsFilter color={"#141c54"} size={25} /> ) next to tab header indicates there is value present with that tab.</span>,
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Dark blue check icon ( <BsCheck color={'#141c54'} size={25} /> ) next to search field indicates there is value present.</span>,
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Use <span style={{ color: '#C31230', fontWeight: 'bold' }}>'No Data'</span> to search for records that do not have data in the field.</span>,
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> Use <span style={{ color: '#141c54', fontWeight: 'bold' }}>'Has Data'</span> to search for records that have data in the field.</span>,
        <span tabIndex={0} role="note" style={{ fontSize: '1.5rem', marginBottom: '1rem', display: 'block' }}><BsFillRecord2Fill color={"#141c54"} size={25} /> To get records for a single day, put the same day in both boxes.</span>,
      ],
      showLoadingResultReport: false,
      reportsGenerating: false,
      selectAllChecked: false,
      reqNumsToDownload: [],
      downloadSummary: {},
      downloadHistoryReqNum: null,
      downloadHistoryRefreshKey: 0,
      counties: [],
    } as any;
    this.submit = this.submit.bind(this);
    this.handleExportToCSV = this.handleExportToCSV.bind(this);
    this.sampleFilterTabsRef = React.createRef();
    this.viewPDFNewTab = this.viewPDFNewTab.bind(this);
    this.paymentFormRef = React.createRef();
    // this.handlePaymentInfo = this.handlePaymentInfo.bind(this);
  }

  addNullSelection(data) {
    return data.concat([
      { label: "No Data", value: "*null", color: '#C31230', fontWeight: 'bold' },
      { label: "Has Data", value: "<>null", color: '#141c54', fontWeight: 'bold' },
    ]);
  }

  submit(page) {
    this.setState({ showLoading: true }, async () => {
      hideModal(SamplesModal.ID);
      document.querySelectorAll('.sampleDownloadCheckbox').forEach((checkbox: HTMLInputElement) => {
        if (checkbox.checked) {
          checkbox.checked = false;
        }
        this.setState({ selectAllChecked: false, reqNumsToDownload: [] });
      })
      try {
        let returnedFilteredObj = this.sampleFilterTabsRef.current.preSubmitChecks()
        if (!returnedFilteredObj) {
          this.setState({ tableData: [], showLoading: false, selected_page: { label: 1, value: 1 } });
          return
        }

        let result = await SamplesAPI.getFilteredSamples(page, {
          filter: returnedFilteredObj,
        });
        if (result.totalSamples < 1) {
          sweetalert.fire({
            icon: "error",
            title: "",
            text: "No samples found",
          });
          this.setState({ showLoading: false, tableData: [], totalSamples: 0, selected_page: { label: 1, value: 1 } });
          return;
        }
        hideModal(SamplesModal.ID);
        this.setState({
          totalSamples: result.totalSamples,
          showLoading: false,
          page_options: getPageOptions(result.num_pages),
          tableData: result.table_data,
          searched: returnedFilteredObj,
          selected_page: { label: page, value: page },
          downloadSummary: {}
        }, () => this.loadDownloadSummary());
      } catch (e) {
        console.error(e);
        sweetalert.fire({
          icon: "error",
          title: "",
          text: "Search failed. Please try again.",
        });
        this.setState({ tableData: [], showLoading: false, selected_page: { label: 1, value: 1 } });
      }
    });
  }

  async loadData() {
    await Promise.all([
      AdminAPI.getPermissions().then((data) => {
        this.setState({
          isGlobalAdminorLab: data.isGlobalAdminorLab,
          isGlobal: data.isGlobal,
          isAdmin: data.isAdmin,
        });
      }),
      SystemAPI.getAllStates().then((data) => {
        this.setState({ states: this.addNullSelection(data) });
      }),
      SystemAPI.statuses().then((data) => {
        this.setState({ statuses: this.addNullSelection(data) });
      }),
      SystemAPI.getAllCountries().then((data) => {
        this.setState({ countries: this.addNullSelection(data) })
      }),
      SystemAPI.getAllRaces().then((data) => {
        this.setState({ race: this.addNullSelection(data) })
      }),
      SystemAPI.getAllGenders().then((data) => {
        this.setState({ gender: this.addNullSelection(data) })
      }),
      SystemAPI.getAllEthnicities().then((data) => {
        this.setState({ ethnicity: this.addNullSelection(data) })
      }),
      SystemAPI.getAllSpecimenSources().then((data) => {
        this.setState({ specimen_source: this.addNullSelection(data) })
      }),
      TestsAPI.getValidSpecimenSources().then((data) => {
        this.setState({ validSpecimenSources: data })
      }),
      SystemAPI.getAllTests().then((data) => {
        this.setState({ tests: this.addNullSelection(data) })
      }),
      // TestsAPI.getAllTestDetails().then((data) => {
      //   this.setState({ testDetails: data.tests })
      // }),
      TestsAPI.getAll().then((data) => {
        this.setState({ testDetails: data.tests })
      }),
      AdminAPI.getAllResultTypes().then((data) => {
        this.setState({ resultTypes: this.addNullSelection(data) })
      }),
      TestsAPI.getValidResultTypes().then((data) => {
        this.setState({ validResultTypes: data })
      }),
      AdminAPI.getAllPods(true).then((response) => {
        const today = moment().startOf('day')
        let pods = response.data as { label: string, value: PodSchedForSelect }[]

        const beforeToday = pods.filter((pods) => {
          let aDate = moment(pods.value.TestDate, 'YYYY-MM-DD').startOf('day')
          return aDate.isBefore(today)
        }).reverse()

        const afterToday = pods.filter((pods) => {
          let bDate = moment(pods.value.TestDate, 'YYYY-MM-DD').startOf('day')
          return bDate.isSameOrAfter(today)
        })
        let groupedPods = [
          { label: "Upcoming", options: afterToday },
          { label: "Past", options: beforeToday }
        ]
        this.setState({ podsForModal: this.addNullSelection(groupedPods) })
      }),
      CustomFieldsAPI.getAllCustomFields().then((data) => {
        this.setState({
          customFields: data.data.customFields.filter(f => f.Options.validPages.includes("Submission Form") || f.Options.validPages.includes("Submission") || f.Options.validPages.includes(AdminPages.HumanSamples)),
          customQuestions: data.data.customQuestions,
          customPatientFields: data.data.customPatientFields
        })
      }),
      BatchesAPI.getBatchesForSamples().then((data) => {
        this.setState({ batchesForModal: data })
      }),
      ServicesAPI.getAllHumanServices().then((data) => {
        this.setState({
          services: data.data,
        })
      }),
      BatchesAPI.getAllBatches().then((data) => {
        let batchesMapped = data.map((b) => {
          return {
            label: b.BatchNum,
            value: b.ID,
          }
        })
        this.setState({
          batchesForFilter: this.addNullSelection(batchesMapped),
        })
      }),
      BinAPI.getBinsForSamples().then((data) => {
        this.setState({ binIDsForModal: data })
      }),
      BinAPI.getAllBins().then((data) => {
        let binsMapped = data.map((b) => {
          return {
            label: b.BinID,
            value: b.ID,
          }
        })
        this.setState({ binIDsForFilter: this.addNullSelection(binsMapped) })
      }),
      BinAPI.getBinsForSamples().then((data) => {
        this.setState({ binIDs: this.addNullSelection(data) } as any)
      }),
      ProviderAPI.getAllSubmittingProviders().then((response) => {
        this.setState({
          submittingProviderList: response.data
        })
      }),
      SystemAPI.getAllCounties().then((response) => {
        let allCountyData = response.counties;
        let countiesForDropdown = allCountyData.map((c) => {
          return {
            label: c.County,
            value: c.State,
          }
        })
        this.setState({
          counties: this.addNullSelection(countiesForDropdown),
        })
      }),
      AdminAPI.getFacilitiesForSubmissionForm().then((data) => {
        let facilityNamesMapped = data.authorizedFacilities.map((fac) => {
          return {
            label: fac.FacilityName,
            value: fac.ID,
          }
        })

        let facilityGroupsMapped = data.authorizedFacilities.filter((f) => {
          let facilityIsConsentEntity = f.FacilitySeq != 1 && f.OktaID != null
          if (facilityIsConsentEntity || f.FacilitySeq === 1) return f
        })

        facilityGroupsMapped = facilityGroupsMapped.filter(
          (f) => f.FacilitySeq === 1
        )
        let facilityGroupsMappedNew = facilityGroupsMapped.map((fac) => {
          return {
            label: fac.FacilityGroup,
            value: fac.FacilityGroup,
          }
        })
        facilityGroupsMappedNew = facilityGroupsMappedNew.sort((a, b) => {
          let firstIndex = a.value.indexOf(" ")
          let first = a.value.slice(firstIndex)
          let secondIndex = b.value.indexOf(" ")
          let second = b.value.slice(secondIndex)
          return first - second
        })
        this.setState({
          facilities: this.addNullSelection(facilityNamesMapped),
          facilityGroups: this.addNullSelection(facilityGroupsMappedNew),
          facilitiesForSampleModal: data.authorizedFacilities.map(f => { return { label: f.FacilityName, value: f.ID, FacilityAbbreviation: f.FacilityAbbreviation } }),
        })
      }),
    ])

    fetchFieldPermissions((state) => this.setState(state as any));

    this.submit(1);
  }

  async componentDidMount() {
    document.title = 'Samples Page';
    const query = new URLSearchParams(window.location.search);

    // reqNum was already read in the constructor; drop it so a refresh doesn't bring the filter back
    if (query.has('reqNum')) {
      const remaining = new URLSearchParams(query);
      remaining.delete('reqNum');
      const search = remaining.toString();
      window.history.replaceState(window.history.state, '', window.location.pathname + (search ? `?${search}` : ''));
    }

    const facilityID = query.get('f');
    const processing = query.get('p');
    const completed = query.get('c');

    // Set initial state based on query params
    this.setState({
      facilityIDFromAdminHomeButtons: facilityID ? Number(facilityID) : undefined,
      processing: !!Number(processing),
      completed: !!Number(completed),
      showLoading: true
    }, () => {
      this.loadData(); // Function to load data from various APIs
    });
  }



  handleExportToCSV() {
    let filter = this.state.searched;
    if (this.state.isGlobalAdminorLab) {
      sweetalert
        .fire({
          title: "Should your export include Patient Identifiers?",
          showCloseButton: true,
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Include",
          denyButtonText: `Don't include`,
        })
        .then((result) => {
          if (result.isConfirmed || result.isDenied) {
            let modifiedfilter = Object.assign(filter, {
              IncludePHI: result.isConfirmed ? true : false,
            });
            this.setState({ showLoading: true }, async () => {
              await NetworkUtil.downloadCSV(
                "/api/admin/samples/results/csv",
                "Sample Results.xlsx",
                { filter: modifiedfilter });
              this.setState({ showLoading: false });
            });
          }
        });
    } else {
      this.setState({ showLoading: true }, async () => {
        await NetworkUtil.downloadCSV(
          "/api/admin/samples/results/csv",
          "Sample Results.xlsx",
          { filter: filter, IncludePHI: false });
        this.setState({ showLoading: false });
      });
    }
  }

  handleDownloadPDFs = async () => {
    sweetalert
      .fire({
        title: "What PDFs would you like to download?",
        showCloseButton: true,
        showDenyButton: true,
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: "Result Reports",
        denyButtonText: `Requisition Forms`,
      })
      .then(async (result) => {
        let PDFTypeToDownload: ReportType = result.isConfirmed ? "ResultReport" : "RequisitionForm";
        if (result.isDismissed) {
          return;
        }
        // Warn before re-downloading reports that were already viewed.
        const alreadyViewed = this.state.reqNumsToDownload
          .map(r => this.state.downloadSummary?.[r.reqNum]?.[PDFTypeToDownload])
          .filter(s => !!s);
        if (alreadyViewed.length > 0) {
          const tz = moment.tz.guess();
          const list = alreadyViewed
            .map(s => `<li>${escapeHTML(s.ReqNum)} - last viewed ${moment.tz(s.LastDownloadedDate, tz).format('MM/DD/YYYY h:mm A')}</li>`)
            .join("");
          const confirm = await sweetalert.fire({
            icon: "warning",
            title: "Already viewed",
            html: `<div class="text-left">${alreadyViewed.length} of the selected samples already had their ${REPORT_TYPE_LABELS[PDFTypeToDownload]} viewed:<ul class="mt-2" style="max-height: 200px; overflow-y: auto;">${list}</ul>Download anyway?</div>`,
            showCancelButton: true,
            confirmButtonText: "Download Anyway",
            cancelButtonText: "Cancel",
          });
          if (!confirm.isConfirmed) {
            return;
          }
        }
        const downloadedReqNums = this.state.reqNumsToDownload.map(r => r.reqNum);
        if (PDFTypeToDownload === "ResultReport") {
          return this.downloadResultReports(downloadedReqNums);
        }
        this.setState({ showLoading: true }, async () => {
          SamplesAPI.downloadPDFs(this.state.reqNumsToDownload, PDFTypeToDownload).then(async (response) => {
            try {
              if (!(response instanceof Blob)) {
                this.setState({ showLoading: false });
                return sweetalert.fire({
                icon: "error",
                title: "",
                text: response?.reason || "Failed to download PDFs.",
                });
              }
              const url = URL.createObjectURL(response);
              window.open(url, '_blank');
              this.handleReportDownloaded(downloadedReqNums);
            } catch (err) {
              console.error(err);
              sweetalert.fire({
                icon: "error",
                title: "",
                text: "Failed to open PDF.",
              });
            }
            this.setState({ showLoading: false });
          })
        })
      });
  }

  // Result reports are pulled from STARLIMS per sample; any sample without a report is skipped
  // by the backend, so tell the user which ones were left out instead of silently returning fewer.
  downloadResultReports = (reqNums: string[]) => {
    this.setState({ showLoading: true }, async () => {
      try {
        const response = await SamplesAPI.downloadResultReportPDFs(this.state.reqNumsToDownload);
        this.setState({ showLoading: false });
        if (response.error || !response.blob) {
          return sweetalert.fire({
            icon: "error",
            title: "",
            text: response.error?.reason || "Failed to download PDFs.",
          });
        }
        const url = URL.createObjectURL(response.blob);
        window.open(url, '_blank');
        const skipped = response.skippedReqNums;
        this.handleReportDownloaded(reqNums.filter(r => !skipped.includes(r)));
        if (skipped.length > 0) {
          const list = skipped.map(r => `<li>${escapeHTML(r)}</li>`).join("");
          sweetalert.fire({
            icon: "warning",
            title: "Some reports were not included",
            html: `<div class="text-left">${reqNums.length - skipped.length} of ${reqNums.length} reports downloaded. No report is available yet for:<ul class="mt-2" style="max-height: 200px; overflow-y: auto;">${list}</ul></div>`,
          });
        }
      } catch (err) {
        console.error(err);
        this.setState({ showLoading: false });
        sweetalert.fire({
          icon: "error",
          title: "",
          text: "Failed to download PDFs.",
        });
      }
    });
  }

  // Loads download counts for the given samples (defaults to the current page) and
  // merges them into state so the "Reports Viewed" column stays current.
  loadDownloadSummary = async (reqNums?: string[]) => {
    const targetReqNums = reqNums || (this.state.tableData || []).map((s: Sample) => s.ReqNum).filter(r => !!r);
    if (targetReqNums.length === 0) {
      return;
    }
    try {
      const response = await SamplesAPI.getReportDownloadSummary(targetReqNums);
      if (!response.success) {
        console.error("getReportDownloadSummary failed", response.reason);
        return;
      }
      this.setState(prevState => {
        const downloadSummary = { ...prevState.downloadSummary };
        targetReqNums.forEach(r => { delete downloadSummary[r]; });
        (response.data || []).forEach(s => {
          downloadSummary[s.ReqNum] = { ...downloadSummary[s.ReqNum], [s.ReportType]: s };
        });
        return { downloadSummary };
      });
    } catch (e) {
      console.error("getReportDownloadSummary error", e);
    }
  }

  handleReportDownloaded = (reqNums: string[]) => {
    this.loadDownloadSummary(reqNums);
    this.setState(prevState => ({ downloadHistoryRefreshKey: (prevState.downloadHistoryRefreshKey || 0) + 1 }));
  }

  useSorter(col: Column) {
    let sorter = new Sorter<Sample>().withRawSorterFunc("Name", (a, b) => {
      let aName = a.PatientFirstName + " " + a.PatientLastName;
      let bName = b.PatientFirstName + " " + b.PatientLastName;
      return aName.localeCompare(bName);
    });
    this.setState({
      tableData: sorter.sortByKey(
        this.state.tableData,
        col.key as keyof Sample,
        this.state.direction
      ),
      direction: this.state.direction === "asc" ? "desc" : "asc",
    });
  }

  handleSetResultsAccessed(val) {
    this.setState({ showLoading: true }, async () => {
      try {
        let result = await SamplesAPI.updateResultsAccessedDate(val.ID);
        if (!result.success) {
          sweetalert.fire({ icon: "error", title: "", text: result.reason });
          this.setState({ showLoading: false });
          return;
        } else {
          sweetalert.fire({
            icon: "success",
            title: "",
            text: "Sample has been updated",
          });
          this.setState({ showLoading: false });
          await this.submit(1);
        }
      } catch (e) {
        console.error(e);
        sweetalert.fire({ icon: "error", title: "", text: "Server error" });
        this.setState({ showLoading: false });
      }
    });
  }

  needsPhysicianReview(selectedSample) {
    //check service for EmailReportTo === 1
    let emailReportTo = this.state.services && selectedSample && selectedSample.ServiceID && (new Date('2023-05-18') < new Date(selectedSample.CreatedDate)) ? this.state.services.find(s => s.ID === selectedSample.ServiceID).EmailReportTo : null
    //check sample for HasPhysicianReviewed
    if (emailReportTo === 1) {
      return true
    }
    return false
  }

  removeStandardPatientFields() {
    let customPatientFieldCopy = this.state.customPatientFields ? JSON.parse(JSON.stringify(this.state.customPatientFields)) : [];
    customPatientFieldCopy = customPatientFieldCopy.filter(f => !standardPatientFields.includes(f.DisplayName))
    return customPatientFieldCopy;
  }

  async viewPDFNewTab(path) {
    const reqNum = this.state.selectedSample?.ReqNum;
    let opened = false;
    if (path && path.includes("Sample_Requisition_Forms")) {
      let report;
      try {
        this.setState({ showLoadingResultReport: true }, async () => {
          //If the Generate Req Form button is clicked, it just passed "Sample_Requisition_Forms", instead of a path to the file
          if (path === "Sample_Requisition_Forms") {
            let generate = await SamplesAPI.generateRequisitionFormForReqNum(this.state.selectedSample.ReqNum);
            if (generate && generate.data) {
              report = await SamplesAPI.viewRequisitionForm(generate.data);
              opened = await openPDFInNewTab(report);
            }
          } else {
            report = await SamplesAPI.viewRequisitionForm(path);
            opened = await openPDFInNewTab(report);
          }
          if (opened) {
            this.handleReportDownloaded([reqNum]);
          }
          this.setState({ showLoadingResultReport: false })
        })
      } catch (error) {
        console.error(error);
        sweetalert.fire({ icon: "error", title: "Error", text: `Error opening report for viewing` })
      }
    } else {

      let report;
      try {
        this.setState({ showLoadingResultReport: true }, async () => {
          if (path === null) {
            let generate = await SamplesAPI.generateResultReportForReqNum(this.state.selectedSample.ReqNum);
            if (generate && generate.data) {
              report = await SamplesAPI.viewResultReport(generate.data);
              opened = await openPDFInNewTab(report);
            }
          } else {
            report = await SamplesAPI.viewResultReport(path);
            opened = await openPDFInNewTab(report);
          }
          if (opened) {
            this.handleReportDownloaded([reqNum]);
          }
          this.setState({ showLoadingResultReport: false })
        })
      } catch (error) {
        console.error(error);
        sweetalert.fire({ icon: "error", title: "Error", text: `Error opening report for viewing` })
      }
    }
  }

  refreshSelectedFacility() {
    // ANetCustomerProfile created for Facility via PaymentFormModal
    // reload facilities and selectedFacility passed into PaymentFormModal?
    // AdminAPI.getFacilitiesForSubmissionForm().then(data => {
    //   this.setState({
    //     facilities: data.authorizedFacilities,
    //     facilityLabels: getSelectLabels(data.authorizedFacilities)
    //   })
    // })
    return;
  }


  render(): | React.ReactElement | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

    // console.log('SamplesReport state', this.state)

    const isDataLoaded = this.state.facilities?.length > 0 && this.state.services?.length > 0;

    let services = this.state.services ? this.state.services.map(s => { return { label: s.Name, value: s.ID } }) : []
    services = this.state.services ? this.addNullSelection(services) : services;
    // Any Essential Service with test result date after release is eligible for 'Upgrade'

    return (
      <React.Fragment>
        <PaginationTool />
        <div className="container-fluid  min-vh-100 ">
          <Overlay show_loading={this.state.showLoading} />
          <Overlay show_loading={this.state.showLoadingResultReport} zIndex={100010} />

          <SamplesModal
            key={this.state.selectedSample && this.state.selectedSample.ID ? this.state.selectedSample.ID : 'new'}
            onSubmit={(reportsGenerating) => { this.setState({ reportsGenerating: !!reportsGenerating }); this.submit(this.state.selected_page.value); if (reportsGenerating) { setTimeout(() => this.setState({ reportsGenerating: false }), 15000); } }}
            isAdmin={this.state.isAdmin}
            isGlobal={this.state.isGlobal}
            getResultsButtonBoolean={this.state.getResultsButtonEnabled}
            getPhysicianReviewButtonBoolean={this.needsPhysicianReview(this.state.selectedSample)}
            selectedSample={
              this.state.selectedSample ? this.state.selectedSample : {}
            }
            states={removeNull(this.state.states)}
            statuses={removeNull(this.state.statuses)}
            countries={removeNull(this.state.countries)}
            counties={removeNull(this.state.counties)}
            ethnicity={removeNull(this.state.ethnicity)}
            race={removeNull(this.state.race)}
            gender={removeNull(this.state.gender)}
            specimen_source={this.state.specimen_source}
            validSpecimenSources={this.state.validSpecimenSources}
            batches={this.state.batchesForModal}
            binIDs={this.state.binIDsForModal}
            testDetails={this.state.testDetails}
            tests={removeNull(this.state.tests)}
            result_types={this.state.resultTypes}
            validResultTypes={this.state.validResultTypes}
            facilities={this.state.facilitiesForSampleModal}
            pods={removeNull(this.state.podsForModal)}
            customFields={this.state.customFields}
            customQuestions={this.state.customQuestions}
            services={this.state.services}
            customPatientFields={this.removeStandardPatientFields()}
            submittingProviderList={this.state.submittingProviderList}
            userRoles={this.state.userRoles}
            fieldPermissions={this.state.fieldPermissions}
            onReportDownloaded={(reqNum) => this.handleReportDownloaded([reqNum])}
            updateSampleState={(sample) => {
              const updatedTableData = this.state.tableData.map((record) => {
                if (record.ReqNum === sample.ReqNum) {
                  return {
                    ...record,
                    TestResultDate: sample.TestResultDate,
                    TestsAndResultsMap: sample.TestsAndResultsMap,
                    TestIDs: sample.TestIDs ?? record.TestIDs,
                    CustomFieldData: sample.CustomFieldData ?? record.CustomFieldData,
                    ProcessedDate: sample.ProcessedDate,
                    ReceivedDate: sample.ReceivedDate,
                    Status: sample.Status,
                    HETLNum: sample.HETLNum,
                    ResultIDs: sample.ResultIDs,
                  };
                }
                return record;
              });
              this.setState({ tableData: updatedTableData , getResultsButtonEnabled: true});
            }}
            onClose={() => {
              this.setState({
                selectedSample: null
              })
            }}
          />

          <HintModal
            handleInBetweenOverlay={() => { }}
            label={"Sample Filters"}
            header={this.state.hintHeader}
            content={this.state.hintContent}
          />

          <ViewTestInfoModal
            selectedSample={this.state.selectedSample ? this.state.selectedSample : {}}
            tests={this.state.tests}
            results={this.state.resultTypes}
            services={this.state.services}
            getResultsButtonBoolean={this.state.getResultsButtonEnabled}
            onReportDownloaded={(reqNum) => this.handleReportDownloaded([reqNum])}
          />

          <ReportSelectModal header="Result Report"
            zIndex={100009}
            reqNum={this.state.selectedSample?.ReqNum}
            reportsGenerating={this.state.reportsGenerating}
            handleInBetweenOverlay={() => { }}
            handleViewPDF={(filePath) => {
              this.viewPDFNewTab(filePath);
            }}
          />

          <ReportDownloadHistoryModal
            reqNum={this.state.downloadHistoryReqNum}
            refreshKey={this.state.downloadHistoryRefreshKey}
          />

          <ReqFormSelectModal
            header="Requisition Form"
            zIndex={100008}
            reqNum={this.state.selectedSample?.ReqNum}
            handleInBetweenOverlay={() => { }}
            handleViewPDF={(filePath) => {
              this.viewPDFNewTab(filePath);
            }}
          />

          <div className="container-fluid  min-vh-100 ">
            <main id="main-content" tabIndex={-1} aria-label="Samples">
              {isDataLoaded && (
                <div className="card m-2">
                  <div className="card-header verlag-bold text-center text-md-left" style={{ height: "4em" }}>
                    <h4 >
                      Human Samples{" "}
                      <FaInfoCircle
                        tabIndex={0}
                        aria-label="Sample Filter Hints"
                        role="button"
                        className={"ml-1"}
                        size={25}
                        color={"#141c54"}
                        onClick={() => showModalNoOutsideClick(HintModal.ID)}
                        onKeyDown={e => {
                          if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            showModalNoOutsideClick(HintModal.ID);
                          }
                        }}
                      />
                    </h4>
                  </div>


                  <SampleFilterTabs
                    ref={this.sampleFilterTabsRef}
                    services={services}
                    batchesForFilter={this.state.batchesForFilter}
                    binIDsForFilter={this.state.binIDsForFilter}
                    resultTypes={this.state.resultTypes}
                    specimenSources={this.state.specimen_source}
                    tests={this.state.tests}
                    pods={this.state.podsForModal}
                    facilityGroups={this.state.facilityGroups}
                    facilities={this.state.facilities}
                    states={this.state.states}
                    statuses={this.state.statuses}
                    countries={this.state.countries}
                    ethnicity={this.state.ethnicity}
                    race={this.state.race}
                    gender={this.state.gender}
                    initialReqNum={this.state.reqNumFromURL}
                    fromAdminHomeButtons={{ FacilityID: this.state.facilityIDFromAdminHomeButtons, processing: this.state.processing, completed: this.state.completed }}
                    submittingProviderList={this.state.submittingProviderList}
                    counties={this.state.counties}
                  />


                  <div className="card-footer" style={{ height: "4em" }}>
                    <button
                      className="btn mr-md-5 float-right verlag-bold immyClearButtonOutline"
                      onClick={() => {
                        this.sampleFilterTabsRef.current.clear();
                      }}
                    >
                      Clear Filters
                    </button>
                    <button
                      className="btn mr-md-2 float-right verlag-bold btn-outline-success"
                      onClick={() => {
                        this.setState({ showLoading: true }, async () => {
                          SamplesAPI.getTodaySamples().then((result) => {
                            try {
                              if (result.totalSamples < 1) {
                                sweetalert.fire({
                                  icon: "error",
                                  title: "",
                                  text: "No samples found",
                                });
                                this.setState({ showLoading: false, tableData: [], totalSamples: 0, selected_page: { label: 1, value: 1 } });
                                return;
                              }
                              hideModal(SamplesModal.ID);
                              this.setState({
                                totalSamples: result.totalSamples,
                                showLoading: false,
                                page_options: getPageOptions(result.num_pages),
                                tableData: result.table_data,
                                selected_page: { label: 1, value: 1 }
                              });
                            } catch (e) {
                              console.error(e);
                              sweetalert.fire({
                                icon: "error",
                                title: "",
                                text: "Search failed. Please try again.",
                              });
                              this.setState({ tableData: [], showLoading: false, selected_page: { label: 1, value: 1 } });
                            }
                          })
                        })
                      }}
                    >
                      Today
                    </button>
                    <button
                      className={"btn verlag-bold immySubmitButtonOutline"}
                      onClick={() => this.submit(1)}
                    >
                      Search
                    </button>
                  </div>
                </div>
              )}

              {this.state.totalSamples > 0 ? (
                <div className="col-12 pt-2 pr-0 pl-0 pb-3">
                  <div className="card m-2 mb-5">
                    <div className="card-header verlag-bold stickToTop">
                      <h4 className={"text-center text-md-left"}>
                        Samples
                        <button
                          className={
                            this.state.totalSamples < 1
                              ? "d-none"
                              : "btn btn-outline-primary d-none d-md-inline-block d-xxl-inline-block ml-2"
                          }
                          onClick={() => this.handleExportToCSV()}
                        >
                          Export to CSV
                        </button>
                        <ReactToPrint
                          trigger={() => (
                            <button
                              className={
                                this.state.totalSamples < 1
                                  ? "d-none"
                                  : "btn btn-outline-success ml-2 d-none d-md-inline-block d-xxl-inline-block"
                              }
                            >
                              Print Grid to PDF
                            </button>
                          )}
                          // @ts-ignore
                          content={() => this.componentRef}
                        />
                        {this.state.reqNumsToDownload.length > 0 && <button
                          className={
                            this.state.totalSamples < 1
                              ? "d-none"
                              : "btn btn-outline-dark d-none d-md-inline-block d-xxl-inline-block ml-2"
                          }
                          onClick={() => this.handleDownloadPDFs()}
                        >
                          Download PDFs
                        </button>}
                        {/* uncomment if want to Print Results to PDF again.  will need reworked for multiple report types  */}
                        {/* <ReactToPrint
                        trigger={() => (
                          <button
                            className={
                              this.state.totalSamples < 1
                                ? "d-none"
                                : "btn btn-outline-success ml-2 d-none d-md-none d-lg-inline-block d-xxl-inline-block"
                            }
                          >
                            Print Results to PDF
                          </button>
                        )}
                        // @ts-ignore
                        content={() => this.componentRefBR}
                        onBeforeGetContent={() => {
                          if (
                            !this.state.tableData ||
                            this.state.tableData.length === 0
                          ) {
                            sweetalert.fire({
                              icon: "error",
                              title: "",
                              text: "No samples found",
                            });
                            return;
                          }
                          return new Promise<void>((resolve, reject) => {
                            this.setState({ showLoading: true }, () => {
                              fetch(
                                domain +
                                  "/api/admin/sampleReport?page=" +
                                  this.state.selected_page.value,
                                {
                                  method: "POST",
                                  body: JSON.stringify({
                                    filter: this.state.filteredObj,
                                  }),
                                  headers: {
                                    "Content-Type": "application/json",
                                  },
                                }
                              )
                                .then((res) => res.json())
                                .then((data) => {
                                  this.setState({
                                    pdfData: data.pdfData,
                                    showLoading: false,
                                  });
                                  resolve();
                                })
                                .catch((e) => {
                                  console.error(e);
                                  sweetalert.fire({
                                    icon: "error",
                                    title: "",
                                    text: "Export failed. Please try again.",
                                  });
                                  this.setState({
                                    pdfData: [],
                                    showLoading: false,
                                  });
                                  resolve();
                                });
                            });
                          });
                        }}
                      /> */}
                        <section className="tableHeaderSection float-md-right d-flex justify-content-around">

                          <div className={"float-right h4"} aria-label="Total Records" role="alert">
                            Total: {this.state.totalSamples}
                          </div>
                          <div className="pl-5 pl-md-0 float-md-right align-items-md-center pr-2 ml-md-5 h4">
                            Page
                          </div>
                          <div className="align-items-md-center float-right pages">
                            <Select
                              isSearchable={true}
                              placeholder={"1"}
                              noOptionsMessage={() => "No option"}
                              aria-label="Table Page Number"
                              value={this.state.selected_page}
                              onChange={(e: ReactSelect) =>
                                this.setState({ selected_page: e }, () => {
                                  this.submit(e.value)
                                })
                              }
                              className={"state_select page-num-select"}
                              options={this.state.page_options}
                            />
                          </div>
                        </section>
                      </h4>
                    </div>

                    <div className="p-0 table-responsive">
                      <SimpleTable ref={el => (this.componentRef = el)} columns={[
                        {
                          label: "Conf #", key: "ReqNum", rawFormat: (val: Sample) => {
                            return <a href={"#top"}
                              className={'tableNameLinkColor'}
                              onClick={() => this.setState({ getResultsButtonEnabled: val.ResultIDs ? !!(JSON.parse(val.ResultIDs).length > 0) : false, selectedSample: JSON.parse(JSON.stringify(val)) }, () => showModalNoOutsideClick(SamplesModal.ID))}>{val.ReqNum}</a>
                          }
                        },
                        {
                          label: "Name", key: "Name", rawFormat: (val: Sample) => {
                            return <div>{val.PatientFirstName + " " + val.PatientLastName}</div>
                          }
                        },
                        { label: "DOB", key: "PatientDOB", formatFunc: parseDate },
                        // {label:"Appt #", key:"LinkedApptsID"},
                        {
                          label: "Collection Date", key: "CollectionDate", rawFormat: (val) => {
                            var tz = moment.tz.guess();
                            return <p>{val.CollectionDate ? moment.tz(val.CollectionDate, tz).format('MM/DD/YYYY') : null }</p>
                          }
                        },
                        { label: "Phone #", key: "PatientPhone" },
                        {
                          label: "Facility", key: "FacilityID", rawFormat: (val) => {
                            if (val.FacilityID) {
                              let facilityName = getNameFromID(val.FacilityID, this.state.facilities);
                              if (!facilityName) {
                                return <p></p>
                              }
                              return <p>{facilityName}</p>
                            }
                            else {
                              return <p></p>
                            }
                          }
                        },
                        { label: "Specimen ID", key: "SpecimenID" },
                        // { label: "Int. Specimen ID", key: "InternalSpecimenID" },
                        // {label:"Batch #", key:"BatchNum"},
                        {
                          label: "Test Order", key: "ServiceID", rawFormat: (val) => {
                            if (val.ServiceID) {
                              let serviceName = getNameFromID(val.ServiceID, this.state.services);
                              if (!serviceName) {
                                return <p></p>
                              }
                              return <p>{serviceName}</p>
                            }
                            else {
                              return <p></p>
                            }
                          }
                        },
                        {
                          label: "Status", key: "Status", rawFormat: (val) => {
                            if (val.Status) {
                              let statusName = getNameFromID(val.Status, this.state.statuses);
                              if (!statusName) {
                                return <p>No Status</p>
                              }
                              return <p>{statusName}</p>
                            }
                            else {
                              return <p></p>
                            }
                          }
                        },
                        {
                          label: "Exists in Starlims", key: "PostedToStarlims", rawFormat: (val: Sample) => {
                            if (val.PostedToStarlims && val.PostedToStarlims === 1) {
                              return <p>Yes</p>
                            } else {
                              return <p>No</p>
                            }
                          }
                        },
                        {
                          label: "Reports Viewed", key: "",
                          rawFormat: (val: Sample) => {
                            const summary = this.state.downloadSummary?.[val.ReqNum];
                            if (!summary || Object.keys(summary).length === 0) {
                              return <div>No</div>
                            }
                            return (
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                aria-label={`View report history for ${val.ReqNum}`}
                                onClick={() => this.setState(prevState => ({
                                  downloadHistoryReqNum: val.ReqNum,
                                  downloadHistoryRefreshKey: (prevState.downloadHistoryRefreshKey || 0) + 1
                                }), () => showModalNoOutsideClick(ReportDownloadHistoryModal.ID))}
                              >
                                View History
                              </button>
                            )
                          }
                        },
                        // {label:"Result Accessed", key:"ResultsAccessedDate",
                        //   rawFormat: (val:Sample) => (
                        //   val.ResultsAccessedDate ? 
                        //   <div>{toLocalDateTime(val.ResultsAccessedDate)}</div> : 
                        //   <button 
                        //     type={'button'} 
                        //     className={val.ResultID ? 'btn btn-outline-success' : "d-none"} 
                        //     onClick={() => this.handleSetResultsAccessed(val)}>Mark as Accessed
                        //   </button> )
                        // },
                        {
                          label: "Test Info", key: "",
                          rawFormat: (val: Sample) => (
                            JSON.parse(val.TestIDs)?.length > 0 ?
                              <button
                                type={'button'}
                                className={'btn btn-outline-success'}
                                onClick={() => this.setState({ getResultsButtonEnabled: val.ResultIDs ? !!(JSON.parse(val.ResultIDs).length > 0) : false, selectedSample: JSON.parse(JSON.stringify(val)) }, () => showModalNoOutsideClick(ViewTestInfoModal.ID))}>{JSON.parse(val.TestIDs).length > 1 ? 'View Tests Info' : 'View Test Info'}
                              </button> : <div>No Test Assigned</div>)
                        },
                        {
                          label: "Select All", key: "",
                          rawFormat: (val: Sample) => (
                            <div className="d-flex align-items-center justify-content-center">
                              <input
                                type="checkbox"
                                aria-label={`Select sample ${val.ReqNum}`}
                                className="form-control sampleDownloadCheckbox"
                                style={{ width: '1em', height: '1em', marginTop: '0.5em' }}
                                // controlled so ticks follow the sample, not the row position, after sorting
                                checked={!!this.state.reqNumsToDownload?.some(record => record.reqNum === val.ReqNum)}
                                onChange={e => {
                                  const reqNum = val.ReqNum;
                                  const isChecked = e.target.checked;
                                  this.setState(prevState => {
                                    let reqNumsToDownload = prevState.reqNumsToDownload ? [...prevState.reqNumsToDownload] : [];
                                    if (isChecked) {
                                      if (!reqNumsToDownload.some(record => record.reqNum === reqNum)) {
                                        reqNumsToDownload.push({ reqNum: reqNum, hasResults: val.TestResultDate ? true : false });
                                      }
                                    } else {
                                      reqNumsToDownload = reqNumsToDownload.filter(record => record.reqNum !== reqNum);
                                    }
                                    return { reqNumsToDownload };
                                  });
                                }}
                              />
                            </div>
                          )
                        },
                      ]} table_data={this.state.tableData} columnClickedCallback={(col => {
                        if (col.label === "Select All") {
                          // Set (not toggle) the selection; row checkboxes render from reqNumsToDownload
                          const selectAll = !this.state.selectAllChecked;
                          this.setState({
                            selectAllChecked: selectAll,
                            reqNumsToDownload: selectAll
                              ? (this.state.tableData || []).filter((v: Sample) => !!v.ReqNum).map((v: Sample) => ({ reqNum: v.ReqNum, hasResults: !!v.TestResultDate }))
                              : []
                          })
                        } else {
                          this.useSorter(col);
                        }
                      })} />
                    </div>
                  </div>
                </div>
              ) : null}
            </main>
          </div>
        </div>

      </React.Fragment>
    );
  }
}